<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-item label="报表名称">
              <a-input placeholder="请输入报表名称" v-model="queryParam.reportName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="报表分组">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="report_group"
                placeholder="请选择报表分组"
                v-model="queryParam.reportGroup"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="是否显示">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="is_open"
                placeholder="是否显示"
                type="checkbox"
                v-model="queryParam.isDisplay"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="客户端">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="client_device"
                placeholder="客户端"
                type="checkbox"
                v-model="queryParam.clientDevice"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('在线报表')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        dragSort
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="url" slot-scope="text">
          <a-button @click="openNewBlank(text)" size="small" type="link">{{text}}</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
        </span>
      </a-table>
    </div>

    <common-onl-report-modal @ok="modalFormOk" ref="modalForm"></common-onl-report-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CommonOnlReportModal from './modules/CommonOnlReportModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'CommonOnlReportList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      CommonOnlReportModal
    },
    data () {
      return {
        description: '在线报表管理页面',
        isorter: {
          column: 'orderNum, reportGroup, reportName',
          order: 'asc'
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '报表名称',
            align: "center",
            dataIndex: 'reportName',
            sorter: true,
          },
          {
            title: '简称',
            align: "center",
            dataIndex: 'shortName',
            sorter: true,
          },
          {
            title: '报表分组',
            align: "center",
            dataIndex: 'reportGroup_dictText',
            sorter: true,
          },
          {
            title: '客户端',
            align: "center",
            dataIndex: 'clientDevice_dictText',
            sorter: true,
          },
          {
            title: '是否显示',
            align: "center",
            dataIndex: 'isDisplay',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['isDisplay'], text) : ''),
            sorter: true,
          },
          {
            title: '排序',
            align: "center",
            dataIndex: 'orderNum',
            sorter: true,
          },
          {
            title: '报表地址',
            align: "left",
            dataIndex: 'url',
            sorter: true,
            scopedSlots: { customRender: 'url' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/custom/commonOnlReport/list",
          delete: "/custom/commonOnlReport/delete",
          deleteBatch: "/custom/commonOnlReport/deleteBatch",
          exportXlsUrl: "/custom/commonOnlReport/exportXls",
          importExcelUrl: "custom/commonOnlReport/importExcel",
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.$set(this.dictOptions, 'isDisplay', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      openNewBlank (url) {
        window.open(url);
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'reportName', text: '报表名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'url', text: '报表地址', dictCode: '' })
        fieldList.push({ type: 'string', value: 'reportGroup', text: '报表分组', dictCode: 'report_group' })
        fieldList.push({ type: 'switch', value: 'isDisplay', text: '是否显示' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>